import EditContribution from '../../components/Contributions/components/Edit';

const ContributionDetail = () => (
    <EditContribution />
);

export default ContributionDetail;
